/**
 * Retrieves the root element for our app.
 */

function getSelectRootElement() {
    let appClassElems = document.querySelectorAll(".novselect-app");

    if (appClassElems && appClassElems.length > 0) {
        return appClassElems[0];
    }
}

function getClosestSelectElement(element) {
	let selectEl = null;

	if(element && element.closest) {
		selectEl = element.closest(".novselect-app");
	}

	return selectEl;
}

// IE 11 doesn't support the closest method on elements so this is a polyfill to add that support
if (!Element.prototype.matches)
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
                                Element.prototype.webkitMatchesSelector;

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;
        if (!document.documentElement.contains(el)) return null;
        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
	};
}

export { getSelectRootElement, getClosestSelectElement };



// WEBPACK FOOTER //
// ./src/lib/DOMHelpers/retrievingDOMElems.js